import type { Jid } from "../../xmpp/jid"

/** The JID's `@` has to survive the URL. */
export function conversationPath(peer: Jid): string {
  return `/messages/${encodeURIComponent(peer)}`
}
